import React, {useEffect, useRef} from "react";
import style from "./GroupSticker.module.css";

const GroupSticker = (props: any) => {
  const wrapperRef: any = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        props.onClickOutSide();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("wheel", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("wheel", handleClickOutside);
    };
  }, [wrapperRef]);

  return (
    <div ref={wrapperRef} className={style.groupStickerContainer}>
      <div className={style.groupSticker}>
        {[...Array(15)].map((item, idx) => {
          return (
            <img
              key={idx}
              width="50px"
              height="50px"
              id={"defaultSticker_0" + idx}
              style={{ cursor: "pointer" }}
              src={`${process.env.PUBLIC_URL}/images/chat-sticker/sticker-${idx}.png`}
              onClick={() => {
                props.onClickSticker({
                  feedID: props.feedID,
                  content: `${process.env.PUBLIC_URL}/images/chat-sticker/sticker-${idx}.png`,
                  // stickerContent: "",
                  type: "sticker",
                  stickerType: "default",
                  stickerId: `defaultSticker_0${idx}`,
                  // tempStickerId: idx,
                  packageId: 0,
                  transactionId: "default",
                });
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default GroupSticker;
